













































import Vue from 'vue';
import { IImage } from '../../../common/interfaces/image.interface';
import CustomButton from '../../layout/buttons/CustomButton.vue';
import ImageHelper from '@/helpers/ImageHelper';
import config from '../../../../config';

interface IImageUploadComponent {
  config: typeof config;
  isAcceptedFileType: boolean;
  isInappropriateImage: boolean;
  isUploadLoading: boolean;
  selectedImage: IImage;
}

export default Vue.extend({
  name: `ImageUpload`,
  components: { CustomButton },
  data(): IImageUploadComponent {
    return {
      config,
      isAcceptedFileType: true,
      isInappropriateImage: false,
      isUploadLoading: false,
      selectedImage: { imageKey: ``, imageUrl: `` },
    };
  },
  computed: {
    isEmpty(): boolean {
      return !this.selectedImage.imageUrl;
    },
    isUploaded(): boolean {
      return (this.alreadyUploadedImage.imageKey && !!this.alreadyUploadedImage.imageKey && !(this.selectedImage.imageUrl instanceof File))
        || (!this.alreadyUploadedImage.imageKey && !(this.selectedImage.imageUrl instanceof File));
    },
    previewImage(): string {
      const previewImageUrl = this.selectedImage.imageUrl instanceof File ? URL.createObjectURL(this.selectedImage.imageUrl) : this.selectedImage.imageUrl;
      return previewImageUrl || `/wp-content/themes/JointsWP/assets/images/human.svg`;
    },
  },
  props: {
    alreadyUploadedImage: {
      default(): IImage {
        return {
          imageUrl: `/wp-content/themes/JointsWP/assets/images/human.svg`,
        };
      },
      type: Object as () => IImage,
    },
    specificFileName: {
      default: ``,
      type: String,
    },
  },
  mounted(): void {
    this.selectedImage = this.alreadyUploadedImage;
  },
  methods: {
    onImageSelected(event: Event): void {
      const target = event.target as HTMLInputElement;
      if([`png`, `jpg`, `jpeg`].includes((target.files?.[0] as File).type.split(`/`)[1])) {
        this.selectedImage.imageUrl = target.files?.[0] as File;
        this.isAcceptedFileType = true;
      } else {
        this.isAcceptedFileType = false;
      }
      target.value = ``;
    },

    async onPostImage(): Promise<void> {
      const imageElement = document.getElementById(`image-upload-preview`) as HTMLImageElement;
      this.isUploadLoading = true;
      if(this.selectedImage.imageUrl instanceof File && !(await ImageHelper.isInappropriateContent(imageElement))) {
        const newFileName = this.specificFileName ? this.specificFileName : this.selectedImage.imageUrl.name;
        this.isInappropriateImage = false;
        this.selectedImage.imageUrl = new File([this.selectedImage.imageUrl], newFileName, { type: this.selectedImage.imageUrl.type });
        this.$emit(`upload:image`, this.selectedImage);
      } else {
        this.isInappropriateImage = true;
      }
      this.isUploadLoading = false;
    },
  },
  watch: {
    alreadyUploadedImage(): void {
      this.selectedImage = this.alreadyUploadedImage;
    },
  },
});
